import * as TooltipPrimitive from '@radix-ui/react-tooltip';

const TooltipProvider = ({ delayDuration = 200, ...props }) => (
    <TooltipPrimitive.Provider
        data-slot='tooltip-provider'
        delayDuration={delayDuration}
        {...props}
    />
);

export default TooltipProvider;
